enum PaymentRequestTrackerName {
  Details = "Details"
}

export default PaymentRequestTrackerName;
